<template>
   <div class="warpNavlan" ref="productRef">
        <div class="box-one" ref="gsap-context">
            <div style="width: 100%;display: flex;justify-content: center;" >
               <div class="center">
                  <div class="title">
                     <span>
                           产品优势
                     </span>
                  </div>
               </div>
            </div>
            <div class="box-line">
               <div></div>
            </div>
        </div>
        <div class="box-two">
            <div class="box">
               <div v-for="(item,index) in list"  class="box-item gsap-BOX-ITEM">
                  <div>
                     <div class="title">
                        {{ item.title }}
                     </div>
                     <div class="box-content">
                        {{ item.content }}
                     </div>
                  </div>
                  <div>
                     <div class="num">0{{ index+1 }}.</div>
                     <div class="line"></div>
                  </div>
               </div>
            </div>
        </div>
   </div>
</template>
<script>
import { gsap } from 'gsap'
export default {
  name: 'child',
  data(){
    return{
      list:[
         {
            title:'便捷的销售渠道',
            content:'嘉马是集合了各种产品和服务的平台，商品讲究的是品与质，用户可以通过嘉马平台轻松找到自己所需要的商品或服务，也可以通过嘉马平台进行购买和支付。对于商家来说入驻嘉马平台可以让其产品和服务的销售量和曝光度提高。'
         },
         {
            title:'更加高效的营销手段',
            content:'嘉马拥有强大的营销和推广能力，可以通过各种营销手段（如：新用户首单特惠、会员制、优惠券、秒杀活动、商品满减、今日甩卖等），吸引更多用户进行购买。商家入驻嘉马平台后，可以利用这些平台提供的营销手段进行商品的营销，提高产品或服务的销售量和知名度。'
         },
         {
            title:'更加专业的售后服务',
            content:'嘉马平台拥有完善的售后服务体系，可以为用户提供更加专业和及时的售后服务，保障用户的消费权益。商家入驻嘉马平台后，可以借助嘉马平台的售后服务体系，提高用户的满意度和忠诚度。'
         }
      ]
    }
  },
  mounted(){
   // this.$nextTick(()=>{
      this.initAnFun()
   // })
  },
  methods:{
   initAnFun(){

      let observer = new IntersectionObserver((enter)=>{
         if(enter[0].isIntersecting){
            let title = this.$refs['gsap-context'];

            gsap.from(title,{
               y:'-100%',
               duration: 3.6,
               ease:'power2.out'
            })
            gsap.from(title,{
               opacity:1,
               duration: 3,
               ease:'power2.out'
            })
            gsap.from('.gsap-BOX-ITEM',{
               y:'100%',
               duration: 3,
               ease:'power2.out'
            })
           observer.unobserve(this.$refs.productRef)
         }
      },{
         root: null,
         threshold: 0.3
      })
      observer.observe(this.$refs.productRef)
   }
  }
}
</script>
<style lang="scss" scoped>
    .warpNavlan{
      width: 100%;
      height: 1080px;
      background: #FFFFFF;
      position: relative;
      background-image: url('../../../assets/product-bg.png');
      background-size: 100% 100%;
      // background-attachment: fixed;
      box-sizing: border-box;
      padding-top: 106px;
      .box-one{
        width: 100%;
        display: flex;
        justify-content: center;
        align-content: center;
        flex-direction: column;
        .center{
          width: 800px;
          height: 98px;
          background-image: url('../../../assets/product-title.png');
          background-size: 100% 100%;
          .title{
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: flex-end;

            span{
               font-size: 40px;
               font-family: Alibaba_Bold;
               color: #FFFFFF;
               line-height: 56px;
            }
          }
        }
        // 
        .box-line{
            margin-top: 16px;
            width: 100%;
            display: flex;
            justify-content: center;
            margin-bottom: 80px;
            div{
               width: 32px;
               height: 3px;
               background: #FFFFFF;
            }
          }
      }
      .box-two{
        width: 100%;
        display: flex;
        justify-content: center;
        .box{
            width: 1200px;
            height: 460px;
            display: flex;
            .box-item{
               width: calc(1200px / 3 - 20px);
               height: 100%;
               margin-right: 20px;
               background-image: url('../../../assets/brand-context-bg3.png');
               // background-repeat: no-repeat;
               box-sizing: border-box;
               padding-top: 70px;
               padding-left: 30px;
               padding-right: 30px;
               padding-bottom: 40px;
               display: flex;
               flex-direction: column;
               justify-content: space-between;
               border-radius: 8px;
               transition: all 0.3s;
               &:hover{
                  background: rgb(54, 124, 255);
                  
               }
               .title{
                  font-size: 20px;
                  font-family: AlibabaPuHuiTi_2_85_Bold;
                  color: #FFFFFF;
                  line-height: 28px;
                  margin-bottom: 34px;
                  font-weight: bold;
               }
               .box-content{
                  font-size: 14px;
                  font-family: AlibabaPuHuiTi_2_55_Regular;
                  color: #FFFFFF;
                  line-height: 22px;
                  opacity: .8;
               }
               .num{
                 width: 100%;
                 text-align: right;
                  font-size: 20px;
                  font-family: Helvetica, Helvetica;
                  font-weight: bold;
                  color: #FFFFFF;
                  line-height: 24px;
                  margin-bottom: 8px;
               }
               .line{
                  width: 100%;
                  height: 1px;
                  background: rgba(255,255,255,0.5);
               }
            }
        }
      }
    }
</style>

